import { availableApps } from "@/composables/useApps";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
    faApple,
    faFacebookMessenger,
    faGoogle,
    faInstagram,
    faTelegram,
    faTwitter,
    faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import {
    faAddressBook,
    faAngleDown,
    faAngleLeft,
    faAnglesLeft,
    faAnglesRight,
    faAngleUp,
    faArchive,
    faArrowDown,
    faArrowDownBigSmall,
    faArrowDownToBracket,
    faArrowLeft,
    faArrowRight,
    faArrowRightFromBracket,
    faArrowRightToBracket,
    faArrowsRotate,
    faArrowTurnDownLeft,
    faArrowTurnDownRight,
    faArrowUp,
    faBan,
    faBars,
    faBell,
    faBoxArchive,
    faBuilding,
    faBullhorn,
    faCalendar,
    faCalendarCheck,
    faCar,
    faCaretRight,
    faChartSimple,
    faCheck,
    faCheckCircle,
    faCheckDouble,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleExclamation,
    faCircleInfo,
    faCircleLeft,
    faCirclePause,
    faCircleRight,
    faCircleXmark,
    faClipboard,
    faClock,
    faCloudArrowDown,
    faComment,
    faCommentDots,
    faCommentLines,
    faComments,
    faCopy,
    faCrown,
    faDotCircle,
    faDownToLine,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faEnvelopeOpen,
    faExclamationTriangle,
    faExternalLink,
    faEye,
    faFile,
    faFileArchive,
    faFileCode,
    faFileCsv,
    faFileExcel,
    faFileExport,
    faFileLines,
    faFilePdf,
    faFilePlus,
    faFiles,
    faFileSpreadsheet,
    faFileText,
    faFileWord,
    faFileXmark,
    faFileZipper,
    faFilm,
    faFilter,
    faFloppyDisk,
    faForwardStep,
    faGear,
    faGift,
    faGrid2,
    faHeadset,
    faHeartRate,
    faHistory,
    faImage,
    faInboxOut,
    faInfoSquare,
    faLaugh,
    faLeftLong,
    faListAlt,
    faLocationDot,
    faLock,
    faLockOpen,
    faMapLocationDot,
    faMapMarkerAlt,
    faMessageArrowUpRight,
    faMicrophone,
    faMoon,
    faPaperclip,
    faPaperPlane,
    faPaperPlaneTop,
    faPen,
    faPhone,
    faPhoneAlt,
    faPlus,
    faRandom,
    faReply,
    faRobot,
    faScrewdriverWrench,
    faSearch,
    faShieldAlt,
    faSignOutAlt,
    faSlashForward,
    faSortShapesUpAlt,
    faSun,
    faTag,
    faTags,
    faText,
    faThLarge,
    faTimes,
    faTools,
    faTrash,
    faTrashCan,
    faTurnUp,
    faUpRightFromSquare,
    faUser,
    faUserCheck,
    faUserGroup,
    faUsers,
    faVideo,
    faWaveform,
    faWrench,
    faXmark,
    faMicrochipAi,
    faLanguage,
    faUserTie,
    faFaceSmileWink,
    faMessagePen,
    faNotes,
} from "@fortawesome/pro-solid-svg-icons";
import {
    faBracketsCurly,
    faCheckCircle as faCheckCircleRegular,
    faCircleEllipsis,
    faCirclePlay,
    faMagnifyingGlass,
    faMessageSms,
    faTimes as faTimesRegular,
} from "@fortawesome/pro-regular-svg-icons";
import { faQrcode } from "@fortawesome/sharp-solid-svg-icons";
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from "@fortawesome/vue-fontawesome";
import Vue from "vue";

/**
 * Explicitly selecting icons offer the advantage of only bundling the icons that you use in your final bundled file. This allows us to subset Font Awesome's thousands of icons to just the small number that are normally used.
 * https://www.npmjs.com/package/@fortawesome/vue-fontawesome?activeTab=versions
 */
const icons = [
    faChartSimple,
    faAngleDown,
    faAngleUp,
    faAngleLeft,
    faAnglesLeft,
    faAnglesRight,
    faApple,
    faArchive,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowRightToBracket,
    faArrowRightFromBracket,
    faArrowDownToBracket,
    faArrowUp,
    faArrowDown,
    faArrowTurnDownLeft,
    faArrowTurnDownRight,
    faMessageArrowUpRight,
    faBan,
    faBars,
    faBars,
    faBell,
    faBracketsCurly,
    faBullhorn,
    faCheck,
    faCheckCircle,
    faCheckDouble,
    faCheckSquare,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleLeft,
    faCircleRight,
    faCircleEllipsis,
    faCircleExclamation,
    faCircleInfo,
    faCirclePlay,
    faCloudArrowDown,
    faCirclePause,
    faClock,
    faComment,
    faCommentDots,
    faCommentLines,
    faComments,
    faCopy,
    faCrown,
    faDownToLine,
    faExternalLink,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faEnvelopeOpen,
    faExclamationTriangle,
    faFacebookMessenger,
    faForwardStep,
    faFile,
    faFileArchive,
    faFileCode,
    faFileCsv,
    faFileExport,
    faFilePdf,
    faFileSpreadsheet,
    faFileText,
    faFileWord,
    faFileZipper,
    faFiles,
    faFileXmark,
    faFilePlus,
    faFilm,
    faFilter,
    faFloppyDisk,
    faGoogle,
    faGift,
    faHeartRate,
    faHistory,
    faImage,
    faVideo,
    faMicrophone,
    faLocationDot,
    faInboxOut,
    faInfoSquare,
    faInstagram,
    faLaugh,
    faLeftLong,
    faListAlt,
    faLock,
    faLockOpen,
    faMapLocationDot,
    faMapMarkerAlt,
    faMoon,
    faPaperPlaneTop,
    faPaperclip,
    faPen,
    faPhone,
    faPhoneAlt,
    faPlus,
    faRandom,
    faSearch,
    faShieldAlt,
    faSignOutAlt,
    faSlashForward,
    faArrowDownBigSmall,
    faSortShapesUpAlt,
    faSun,
    faTag,
    faTags,
    faThLarge,
    faTimes,
    faTimesRegular,
    faMagnifyingGlass,
    faTools,
    faTrash,
    faTrashCan,
    faTwitter,
    faUpRightFromSquare,
    faUser,
    faUserCheck,
    faUserGroup,
    faHeadset,
    faUsers,
    faWaveform,
    faWhatsapp,
    faTelegram,
    faAddressBook,
    faXmark,
    faBoxArchive,
    faGear,
    faGrid2,
    faCar,
    faBuilding,
    faWrench,
    faScrewdriverWrench,
    faCalendar,
    faDotCircle,
    faCaretRight,
    faEye,
    faCheckCircleRegular,
    faCircleXmark,
    faCalendarCheck,
    faPaperPlane,
    faClipboard,
    faArrowsRotate,
    faMessageSms,
    faText,
    faQrcode,
    faRobot,
    faFileExcel,
    faFileLines,
    faReply,
    faTurnUp,
    faMicrochipAi,
    faLanguage,
    faUserTie,
    faFaceSmileWink,
    faMessagePen,
    faNotes,
];

// Custom kit is also loaded in, can be found in public/index.html
// https://fontawesome.com/kits/0d1577e3b4

for (const app in availableApps) {
    availableApps[app].faIcons?.forEach((newIcon) => {
        if (icons.every((icon) => icon.prefix !== newIcon.prefix || icon.iconName !== newIcon.iconName)) {
            icons.push(newIcon);
        }
    });
}

library.add(icons);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);
